module.exports = __webpack_public_path__ + "img/yeYaBeng5.bd145448.png";